<template>

<div
    class="modal fade"
    id="kt_modal_bibo_reposition"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
  >
  <!--begin::Modal header-->
    <div class="modal-dialog modal-dialog-centered mw-650px"> 
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header flex-stack">
          <!--begin::Title-->
          <h2>Reposition this User ID: {{usid}}</h2>
          <!--end::Title-->

          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal" 
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body scroll-y pt-10 pb-15 px-lg-17">
          <div class="card-body py-3">
              <div class="row mb-5">
                <div class="col-md-12 fv-row py-1">
                  <p>Please enter the <mark>upline ID</mark> and the <mark>position</mark> you want to put <mark>{{usid}}</mark> under. </p>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-3 fv-row py-1"></div>
                <div class="col-md-6 fv-row py-1">
                  <input type="text" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Upline ID" v-model="upid_input">
                </div>
                <div class="col-md-3 fv-row py-1"></div>
              </div>
              <div class="row mb-5">
                <div class="col-md-3 fv-row py-1"></div>
                <div class="col-md-6 fv-row py-1">
                  <select class="form-select form-select-solid" id="position" v-model="position_selected">
                    <option value="XXX">Select Position</option>
                    <option value="L">Left</option>
                    <option value="R">Right</option>
                  </select>
                </div>
                <div class="col-md-3 fv-row py-1"></div>
              </div>
              <div class="row mb-5 text-center">
                <label for="checkboxCHEQUE"><input type="checkbox" id="checkboxCHEQUE" value="" v-on:click="checkBoxValidator($event);" >&nbsp;I want to proceed.</label>
              </div>
              <div class="row mb-5">
             <div class="col-md-12 fv-row py-1 text-center">
              <button class="btn btn-sm btn-info min-w-100px" v-if="isShowProceedBtn" data-bs-toggle="modal" v-on:click="process_repositioning();" > Proceed </button>
            </div>
           </div>
          </div>
          <!--begin::Body-->
        </div>
        <!--begin::Modal body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal header-->
  <!--end::Tables Widget 11-->
  </div>
   
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from 'axios';
import {processPCPRetailerRepositioning}  from "@/api/pcp";


export default defineComponent({
  name: "encashmentprocess", 
  data(){
      return { 
        position_selected : "XXX",
        upid_input : "",
        isShowProceedBtn : false,

      }
  },
  methods: {
    async checkBoxValidator(event){
        if (event.target.checked) {
          this.isShowProceedBtn = true;
        } else {
          this.isShowProceedBtn = false;
        }
      },
      async process_repositioning(){
        
        var param = {
          usid : this.usid,
          upid : this.upid_input,
          position: this.position_selected
        }

        const response = await processPCPRetailerRepositioning(param);
        if(response != null){
          this.isShowProceedBtn = false;

          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
            }); 
            window.location.reload();
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
            }); 
          }
        }
      }
  },
  mounted(){
     
  },
  components: {},
  props: {
    usid: String
  },
   setup(props, context) {
    const usid = props.usid;
   }
});
</script>
